// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__ksged","cell":"ColumnAccessor_cell__2pYFp","firstCellAccent":"ColumnAccessor_firstCellAccent__13z0P"};